const initialState = {
    open: false,
    message : "",
};

const snackbarReducer = (state = initialState, action) => {
    switch (action?.type) {
        case "SNACKBAR_MESSAGE":
            return  {
                ...state,
                open : action?.openMessageToast?.open,
                message : action?.openMessageToast?.message,
            };
        default:
            return state;
    }
}
export default snackbarReducer;